import { useChannelStateContext } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';
import { useEffect, useRef } from 'react';

const ChatContent = ({ children }) => {
    const classes = useStyles();
    const { thread } = useChannelStateContext();
    const chatContentRef = useRef(null);

    useEffect(() => {
        const inThreadMode = !!thread;
        if (chatContentRef.current) {
            // This code replace "hideOnThread" attribute for Window Component
            // because hideOnThread prevent react component to render (return null)
            // what cause us to lose the scroll of the message inside thread and scroll to bottom
            // i decide the best is to do javascript code that will change his display when in thread mode
            // the reason i created component for it => because {thread} from channel context is existed only inside
            // the window
            // and it prettier to encapsulate the logic in separate component and hide it from the chat main component
            const chatContentParent = chatContentRef.current.parentElement;
            chatContentParent.style.display = inThreadMode ? 'none' : 'flex';
        }
    }, [thread]);

    return (
        <div className={classes.container} ref={chatContentRef}>
            {children}
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        },
    }),
    {
        classNamePrefix: 'ChatContent',
    }
);

export default ChatContent;
